import { TrendingUp, Palette, Search } from "lucide-react";

const personas = [
  {
    icon: TrendingUp,
    tag: "For performance marketers",
    title: "Reverse-engineer what's converting.",
    points: [
      "Study competitor creative strategies",
      "Build a private swipe file of proven angles",
      "Spot trends before they hit the mainstream",
    ],
  },
  {
    icon: Palette,
    tag: "For creators & editors",
    title: "Fuel your next winning creative.",
    points: [
      "Reference hooks, pacing, and edits offline",
      "Compare formats: UGC, static, animated",
      "Learn copywriting from top-spending brands",
    ],
  },
  {
    icon: Search,
    tag: "For researchers & analysts",
    title: "Build the archive nobody else has.",
    points: [
      "Track industry-wide messaging shifts",
      "Preserve ads before advertisers pull them",
      "Feed data into your models and reports",
    ],
  },
];

export default function WhoIsThisFor() {
  return (
    <section
      data-testid="personas-section"
      className="relative py-20 md:py-28 border-t border-zinc-200 dark:border-zinc-800"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <p className="text-xs font-mono uppercase tracking-widest text-yellow-500 mb-3">
              // Made for you
            </p>
            <h2 className="font-display font-bold text-4xl md:text-6xl text-zinc-900 dark:text-white tracking-tight leading-[0.95]">
              Whether you spend, create, or study — this is your unfair advantage.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:pl-8">
            <div className="border border-zinc-200 dark:border-zinc-800 bg-white/70 dark:bg-zinc-950/60 p-6">
              <img
                src="https://images.unsplash.com/photo-1528109966604-5a6a4a964e8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHx2aWRlbyUyMGVkaXRvciUyMHdvcmtpbmd8ZW58MHx8fHwxNzg1MDU4ODg4fDA&ixlib=rb-4.1.0&q=85"
                alt="Video editor at work"
                className="w-full aspect-video object-cover"
              />
              <p className="mt-4 text-xs font-mono uppercase tracking-widest text-zinc-500 dark:text-zinc-500">
                Used daily by teams at agencies, DTC brands, and studios.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {personas.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.tag}
                data-testid={`persona-${i}`}
                className="border border-zinc-200 dark:border-zinc-800 bg-zinc-100/60 dark:bg-zinc-950/40 p-8 group hover:border-yellow-500 transition-colors"
              >
                <div className="w-12 h-12 grid place-items-center border border-zinc-200 dark:border-zinc-800 group-hover:border-yellow-500 text-yellow-500">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <p className="mt-6 text-xs font-mono uppercase tracking-widest text-zinc-500 dark:text-zinc-500">
                  {p.tag}
                </p>
                <h3 className="mt-3 font-display font-bold text-2xl text-zinc-900 dark:text-white leading-tight">
                  {p.title}
                </h3>
                <ul className="mt-6 space-y-2 text-sm text-zinc-400 dark:text-zinc-600 dark:text-zinc-400">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2">
                      <span className="text-yellow-500 mt-0.5">→</span>
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
